import React from "react";
export default function SVGPuzzle1() {
  return (
    <svg version="1.1" x="0px" y="0px" viewBox="0 0 512 512">
      <g>
        <g fill="#000000">
          <path
            opacity="0.5"
            d="M277.832,215.568h-36.833V120.5h-80.068V83.667c0-22.33-18.102-40.432-40.432-40.432
       c-22.33,0-40.432,18.102-40.432,40.432V120.5H0V391.5h80.068v-36.833c0-22.33,18.102-40.432,40.432-40.432
       c22.33,0,40.432,18.102,40.432,40.432V391.5h80.068v-95.068h36.833c22.33,0,40.432-18.102,40.432-40.432
       S300.162,215.568,277.832,215.568z"
          />
        </g>
      </g>
      <g>
        <g fill="#000000">
          <path
            d="M431.932,120.5V83.667c0-22.33-18.102-40.432-40.432-40.432c-22.33,0-40.432,18.102-40.432,40.432V120.5h-80.068v65.067
       h6.831c38.837,0,70.433,31.596,70.433,70.433s-31.596,70.433-70.433,70.433h-6.831V391.5h80.068v36.833
       c0,22.33,18.102,40.432,40.432,40.432c22.33,0,40.432-18.102,40.432-40.432V391.5H512V120.5H431.932z"
          />
        </g>
      </g>
    </svg>
  );
}
